import React, { useState } from 'react';
import styled from 'styled-components';
import { Typography } from '../typography/Typography';
import colors from '../../../../tailwind.colors';

const Bubble = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  min-width: 100px;
  padding: 8px;
  position: absolute;
  box-sizing: border-box;
  border-width: 1px;
  border-color: ${colors.customGray[300]};
  top: ${(props) => (props.$direction === 'top' ? 'auto' : '50%')};
  right: ${(props) =>
    props.$direction === 'top' ? 'auto' : 'calc(100% + 20px)'};
  bottom: ${(props) => (props.$direction === 'top' ? '100%' : 'auto')};
  left: ${(props) => (props.$direction === 'top' ? '50%' : 'auto')};
  transform: ${(props) =>
    props.$direction === 'top' ? 'translateX(-50%)' : 'translateY(-50%)'};
  margin-bottom: 15px;

  &:before {
    content: '';
    position: absolute;
    top: ${(props) => (props.$direction === 'top' ? '100%' : '50%')};
    left: ${(props) => (props.$direction === 'top' ? '50%' : '100%')};
    margin-top: ${(props) => (props.$direction === 'top' ? '-7px' : 0)};
    margin-left: ${(props) => (props.$direction === 'top' ? 0 : '-7px')};
    transform: ${(props) =>
      props.$direction === 'top'
        ? 'translateX(-50%) rotate(45deg)'
        : 'translateY(-50%) rotate(-45deg)'};
    width: 15px;
    height: 15px;
    background: white;
    border-bottom: inherit;
    border-right: inherit;
    box-shadow: inherit;
  }
`;

export const Tooltip = ({
  description,
  direction = 'top',
  children,
  ...props
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <span
      onMouseEnter={() => setTooltipOpen(true)}
      onMouseLeave={() => setTooltipOpen(false)}
      className="relative"
      {...props}
    >
      {tooltipOpen && (
        <Bubble $direction={direction}>
          <Typography fontVariant="sm">{description}</Typography>
        </Bubble>
      )}
      {children}
    </span>
  );
};
